import { Input, Button } from "@ui";
import { Form, Formik } from "formik";
import style from "./LoginPage.module.scss";
import * as Yup from 'yup';
import { useAdminLoginMutation } from "@RTKQuery/admin/auth/auth";

export function LoginPage() {
    const [login, { isLoading, error, reset }] = useAdminLoginMutation();

    return (
        <main className={style.page}>
            <p className={style.pageName}>Вхід в кабінет адміністратора</p>
            <Formik
                initialValues={{
                    email: "",
                    password: "",
                }}
                validationSchema={Yup.object({
                    email: Yup.string().email("Неправильний формат пошти").required("Електронна пошта - обов'язкове поле"),
                    password: Yup.string().required("Пароль - обов'язкове поле"),
                })}
                onSubmit={(values) => {
                    login(values)
                }}
            >
                {(props) => (
                    <Form>
                        <div className="flex flex-col gap-[20px] mb-[20px]">
                            <Input
                                label="Електронна пошта"
                                type="email"
                                onChange={(newValue) => {
                                    props.setFieldValue("email", newValue.trim())
                                }}
                                onBlur={props.handleBlur}
                                value={String(props.values.email)}
                                name="email" 
                                customStyle={{
                                    width: "!max-w-[360px]"
                                }}
                                error={props.touched.email ? props.errors.email : ""}
                            />
                            <Input
                                label="Пароль"
                                type="password"
                                onChange={(newValue) => {
                                    props.setFieldValue("password", newValue.trim())
                                }}
                                onBlur={props.handleBlur}
                                value={String(props.values.password)}
                                name="password"
                                customStyle={{
                                    width: "!max-w-[360px]"
                                }}
                                error={props.touched.password ? props.errors.password : ""}
                            />
                        </div>
                        <Button
                            type="submit"
                            color="blue"
                            text="Увійти"
                            customStyle={{
                                width: "!max-w-full !w-full",
                                button: "!max-w-full !w-full  !h-[43px] !w-full !px-[45px]",
                                text: "!text-[16px]"
                            }}
                            loading={isLoading}
                            errors={[
                                (error && ((extractError) => {
                                    return extractError(error)
                                }))
                            ]}
                            resetStatus={() => {
                                reset();
                            }}
                        />
                    </Form>
                )}
            </Formik>
        </main>
    )
}